import { yupValidator } from 'lib/yup-validator';
import ButtonGroup from 'molecules/ButtonGroup';
import Drawer from 'molecules/Drawer';
import { useSession } from 'next-auth/react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import useGlobalToastStore from 'store/globalToastStore';
import * as yup from 'yup';
import AddDelegate from './AddDelegate';

export const accessOptions = [
    {
        label: 'All access',
        value: 'all'
    },
    {
        label: 'Project',
        value: 'project'
    },
    {
        label: 'Requisition',
        value: 'requisition'
    },
    {
        label: 'Profile',
        value: 'profile'
    },
    {
        label: 'Stock/Cash Count',
        value: 'stockCount'
    },
    {
        label: 'work packages',
        value: 'workPackage'
    },
    {
        label: 'Specific Work Package',
        value: 'specificWorkPackage'
    },
    {
        label: 'Specific Project',
        value: 'specificProject'
    },
    {
        label: 'Specific Requisition',
        value: 'specificRequisition'
    },
    {
        label: 'Firm Initiative',
        value: 'firmInitiative'
    },
    {
        label: 'Specific Firm Initiative',
        value: 'specificFirmInitiative'
    },
    {
        label: 'PODs',
        value: 'pod'
    },
    {
        label: 'Specific POD',
        value: 'specificPod'
    }
];

function Delegate({
    onClose,
    valueChanged,
    searchResults = {},
    delegatedActivities = [],
    onDelegate = () => { },
    onRevokeAccess,
    onSubmit,
    updateResources = () => { },
    setResources
}) {
    const [isAdd, setIsAdd] = useState(true);
    const [isEdit, setIsEdit] = useState(false);
    const [showDialog, setShowDialog] = useState('');
    const [selected, setSelected] = useState({});
    const { setToastData } = useGlobalToastStore();
    const session = useSession();
    const isAuditUser = (session?.data?.user?.function === 'Audit & Assurance' && session?.data?.user?.serviceArea === 'Audit') || session?.data?.user?.isAuditRM || session?.data?.user?.grade === 'DM';
    const isSlOrSCLead = session?.data?.user?.role?.includes('service_line_lead') || session?.data?.user?.role?.includes('service_category_lead')
    const isPodLead = session?.data?.user?.role?.includes('pod_lead');

    const {
        control, register, watch, reset, setValue
    } = useForm({
        resolver: yupValidator(
            yup.object().shape({
                access: yup.object().required(),
                selected: yup.object().required(),
                delegateAllIntakeRequests: yup.bool().notRequired()
            })
        ),
        defaultValues: {
            selected: {}
        }
    });

    const accessOptionsForAdd = [
        {
            label: 'All access',
            value: 'all'
        },
        {
            label: 'Project',
            value: 'project'
        },
        ...(isSlOrSCLead ? [{
            label: 'work packages',
            value: 'workPackage'
        }] : []),
        ...(isPodLead ? [{
            label: 'PODs',
            value: 'pod'
        }] : []),
        {
            label: 'Requisition',
            value: 'requisition'
        },
        {
            label: 'Profile',
            value: 'profile'
        },
        {
            label: 'Firm Initiative',
            value: 'firmInitiative'
        },
        ...(isAuditUser ? [{
            label: 'Stock/Cash Count',
            value: 'stockCount'
        }] : [])
    ];

    const actions = [
        {
            label: 'Edit',
            onSelectedItem: (row) => {
                setValue('selected', row);
                setValue('access', row.access);
                setIsAdd(true);
                setIsEdit(true);
            }
        },
        {
            label: 'Revoke access',
            onSelectedItem: (row) => {
                setSelected(row);
                setShowDialog('revoke-access');
            }
        }
    ];

    const label = (delegatedActivities.length && !isAdd) ? 'Done' : isEdit ? 'Update' : 'Delegate activity';

    const buttons = [
        {
            label: 'Cancel',
            kind: 'primary',
            onClick: () => {
                if (isAdd) {
                    setIsAdd(false);
                    setResources && setResources(null);
                    setValue('selected', null);
                    setValue('access', null);
                    setIsAdd(false);
                    setIsEdit(false);
                    onClose();
                } else {
                    onClose();
                }
            },
            size: 'l'
        },
        {
            label,
            kind: 'primaryLoud',
            onClick: () => {
                if (isAdd) {
                    if (!watch('selected')?.id) {
                        setToastData({ show: true, message: 'Please select resource to delegate activity', type: 'error' });
                        return;
                    }
                    if (!watch('access')?.value) {
                        setToastData({ show: true, message: 'Please select access to delegate activity', type: 'error' });
                        return;
                    }

                    onDelegate({ resource: watch('selected'), access: watch('access'), delegateAllIntakeRequests: watch('delegateAllIntakeRequests') ?? false }, isEdit);
                    setIsAdd(false);
                    setIsEdit(false);
                    reset();                    
                    onClose();
                } else {
                    onClose();
                    onSubmit();
                }
            },
            size: 'l',
            className: 'button-custom-text'
        }
    ];

    return (
        <Drawer
            show={true}
            title={isAdd ? `${isEdit ? 'Edit' : 'Add'} delegate` : 'Delegate activity'}
            isFooter={isAdd || delegatedActivities.length > 0}
            onClose={onClose}
            footer={<ButtonGroup buttons={buttons} />}
            headerMargin=''
        >

            {
                isAdd && (
                    <AddDelegate
                        isEdit={isEdit}
                        updateResources={updateResources}
                        searchResults={searchResults}
                        accessOptions={accessOptionsForAdd}
                        control={control}
                        register={register}
                        valueChanged={valueChanged}
                        watch={watch}
                        setValue={setValue}
                    />
                )
            }
        </Drawer>
    );
}

export default Delegate;
